export default function columns(t) {
  return [
    { title: t('general.time'), field: 'timeNotification' },
    {
      title: t('general.type'),
      field: 'typeNotification',
      render: (rowData) =>
        t(`calendar.type-notification.${rowData.typeNotification}`),
    },
    { render: () => t('calendar.info-alert') },
  ];
}
